import React from "react";

const LetsExplore = () => {
  return (
    <div className="w-full py-12 lg:py-18 relative">
      <div className="w-[88%] lg:w-[80%] mx-auto text-center relative">
        {/* Green L-shaped lines */}
        <div className="absolute top-0 right-0 w-1/6 h-1/4 border-r-4 border-t-4 border-fluoro-green"></div>
        <div className="absolute bottom-0 left-0 w-1/6 h-1/4 border-b-4 border-l-4 border-fluoro-green"></div>
        <div className="px-10 py-16 md:py-24">
          {/* Main Heading */}
          <h2 className=" w-[70%] mx-auto text-[32px] lg:text-[48px] xl:text-[56px] text-white RoobertLight leading-[120%] mb-4">
            Let's explore what's possible - together.
          </h2>

          {/* Sub-heading */}
          <h3 className="text-[20px] lg:text-[24px] xl:text-[28px] text-white RoobertMedium leading-[120%] mb-8">
            Outcomes matter. We're ready when you are.
          </h3>

          {/* Call-to-Action Button */}
          <button className="bg-[#66FF00] text-black px-8 py-4 RoobertSemiBold text-[16px] lg:text-[18px] hover:bg-[#5AE600] transition-colors duration-200 rounded-lg">
            <a href="/contact-us">Start the Conversation</a>
          </button>
        </div>
      </div>
    </div>
  );
};

export default LetsExplore;
